export default "__VITE_ASSET__ce9fb72c__"